<template>
  <div class="usercenter-pnr">
    <div class="pnr-wrap">
      <div class="usercenter-title">
        <h2>PNR入库</h2>
      </div>
      <div class="order-wrap">
        <div v-if="!detailView" class="pnr-search">
          <div class="search-bar">
            <a-form :form="form">
              <a-row>
                <a-col :span="20">
                  <a-form-item label="B系统PNR编号" :label-col="{span: 7}" :wrapper-col="{span: 15}">
                    <a-input size="large" v-model="pnrNo"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-button type="primary" size="large" @click="search" :loading="loading">查询</a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <div class="rule-wrap">
            <h4>温馨提示</h4>
            <p>请务必确认如下项目正确无误后进行入库操作：</p>
            <ul class="rule-list">
              <li>请确认该PNR内姓名、航段、舱位正确无误。</li>
              <li>每个乘客均有正确SSR FOID NI格式的身份证件项。</li>
              <li>请确认PNR为时限票编码，不是已出票状态。</li>
              <li>所入库的PNR必须在航班起飞前两个小时操作，否则不能入库。</li>
              <li>建议单航段PNR最多不能超过40个人，往返最多不能超过20个人。</li>
              <li>姓名一样的旅客不能再同一个PNR里出票，否则无法值机。</li>
              <li>暂不支持缺口程，联程PNR入库。</li>
              <li>对于已入库的PNR，请不要在中航信系统（黑屏）上对改PNR再进行任何修改操作，由此造成系统不能出票等问题，后果自负。</li>
              <li>入库PNR暂不支持改期升舱。</li>
              <li>请确认PNR含OIS（Airline）CTCM 或 OSI（Airline）CTCT格式手机号码，且手机号码正确无误。</li>
              <li>对于入库PNR，取消订单或退票后，请检查PNR是否清位，若未清位的，请手工进行处理。</li>
              <li>Y/B/B1/K/K1/M/M1舱免费托运行李额为10公斤，Q/H/X/L/U/E/E1/D/D1/T/T1/I/I1/Z/Z1-Z4/V/N/W舱免费托运行李额为0，请出票后通知旅客。</li>
            </ul>
          </div>
        </div>
        <pnr-detail v-if="detailView" :pnrData="pnrData"></pnr-detail>
      </div>
    </div>
  </div>
</template>
<script>
import './index'
import pnrDetail from './components/pnrDetail'
import { pnrQuery } from '@/apis/agent'
export default {
  data () {
    return {
      form: this.$form.createForm(this),
      pnrNo: '',
      detailView: false,
      pnrData: {},
      loading: false
    }
  },
  methods: {
    async search () {
      this.loading = true
      try {
        const { pnrNo } = this
        const params = {
          pnrNo
        }
        const result = await pnrQuery(params)
        this.loading = false
        this.pnrData = result
        // TODO: mock data
        // this.pnrData.tripType = "MULTIWAY"
        // this.pnrData.tripType = "ONEWAY"
        // this.pnrData.tripType = "ROUNDTRIP"
        this.detailView = true
      } catch (e) {
        this.loading = false
        this.$message.error(e.message)
      }
    }
  },
  components: {
    pnrDetail
  }
}
</script>
<style lang="less" scoped>
.usercenter-pnr {
  padding: 20px;
  .pnr-wrap {
    width: 100%;
  }
  .order-wrap {
    padding-top: 20px;
    color: #808080;
    .search-bar {
      width: 500px;
      margin: 0 auto;
      padding-top: 20px;
    }
  }
  .rule-wrap {
    padding-top: 50px;
    padding-left: 20px;
    line-height: 30px;
    font-size: 14px;
    h4 {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .rule-list {
      margin-left: 20px;
      li {
        list-style-type: decimal;
      }
    }
  }
}
</style>
